// @ts-nocheck
import * as util from '#packages/util';

function getLocale(/*editorAPI, appData, token*/) {
  return util.editorModel.languageCode;
}

export { getLocale };
